module.exports = __webpack_public_path__ + "img/filter.973d5669.jpg";